import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";
import i18n from "i18next";
import { eventEnum, modeEnum } from "@/utils/enum";
import config from "@/utils/config";
import url from "@/utils/url";

class LPHeader extends React.Component {
  componentDidMount() {
    const { scMode } = this.props;
    const element = document.getElementsByClassName("lp-header-container")[0];
    if (element.classList.contains("lp-header-container-normal")) {
      element.classList.remove("lp-header-container-normal");
    }
    if (element.classList.contains("lp-header-container-sticky")) {
      element.classList.remove("lp-header-container-sticky");
    }
    element.classList.add(
      scMode === modeEnum.pageEditing
        ? "lp-header-container-normal"
        : "lp-header-container-sticky"
    );
  }

  login = () => {
    config.eventEmitter.emitEvent(eventEnum.login);
  };

  register = () => {
    const {
      history: { push },
    } = this.props;
    push(url.confirmAgreement);
  };

  refresh = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname === url.lp) {
      getWindow().location.reload();
    } else {
      replace(url.lp);
    }
  };

  render() {
    const { t, className, scMode, isShowRedBar } = this.props;

    return (
      <header
        className={`lp-header-container ${className || ""} ${
          scMode === modeEnum.pageEditing
            ? "lp-header-container-normal"
            : "lp-header-container-sticky"
        }`}
      >
        {isShowRedBar && (
          <div className={`ie-red-bar lp-header-container-ie-red-bar`}>
            <div>{i18n.t("TCCs0018_lp_ie_red_tip")}</div>
          </div>
        )}
        <div className="lp-header-container-top">
          <img
            alt=""
            src={require("@/assets/images/logo_horizontal.svg")}
            onClick={this.refresh}
            tabIndex="0"
          />
          <div className="lp-header-container-button">
            <button
              className="lp-header-container-button-login"
              onClick={this.login}
            >
              {t("common_header_login_title")}
            </button>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    scMode: state?.config?.mode,
  };
};

export default connect(mapStateToProps)(
  withRouter(withTranslation()(LPHeader))
);
